<button
  type="button"
  class="suggestion-chip"
  [disabled]="disabled()"
  (click)="selected.emit()"
>
  <mat-icon class="size-s">{{ icon() }}</mat-icon>
  <span>{{ label() }}</span>
</button>
